import { Component, OnInit, Input } from '@angular/core';
//import * as Highcharts from 'highcharts/highstock';
import { PropertyListingService } from '../../../../shared/providers/property-listing.service';
import { ValidationService } from '../../../../shared/providers/validation.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CommonService } from '../../../../shared/providers/common.service';
import { NewsTickerDetailsModel } from '../../../../shared/models/NewsTickerDetailsModel';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { ToastService } from '../../../../shared/providers/toast.service';
import { SharedService } from '../../../../shared/providers/shared.service';

export enum FinancialSummaryTabs {
  Summary = 1,
  Chart = 2,
  Statistics = 3,
  Profile = 4,
  Financial = 5
}
@Component({
  selector: 'app-credit-profile',
  templateUrl: './credit-profile.component.html',
  styleUrls: ['./credit-profile.component.css']
})

export class CreditProfileComponent implements OnInit {
  financialSummaryTabs = FinancialSummaryTabs;
  financialSummaryActiveTab = this.financialSummaryTabs.Summary;
  @Input() tickerSymbol = "";
  @Input() tenant = "";
  @Input() showSummaryTab = false;
  showSummary = false;
  price = {} as any;
  timeOffset = 0;
  user: any;
  tickerAvailable = true;
  sellerId = 0;
  newsDetail = {} as NewsTickerDetailsModel;
  summaryData: string = null;
  constructor(private propertyListing: PropertyListingService, private shared: SharedService, private authentication: AuthenticationService, protected activatedRoute:
    ActivatedRoute, private _toastService: ToastService, private Loader: LoaderService, private commonService: CommonService, public Validation: ValidationService) { }

  ngOnInit() {

    this.shared.financialSummaryChange.subscribe(res => {
      if (res > 0 && res != undefined) {
        this.loadData(res);
      }
    });
    this.Loader.display(true);
    this.activatedRoute.queryParams.subscribe((params: Params) => {

      if (params["seller"] != null) {
        this.sellerId = params["seller"];
      }

      if (params["ticker"] != null) {
        this.tickerSymbol = params["ticker"];
        this.loadNews();
      }
      else if (this.tickerSymbol == "") {
        this.user = this.authentication.user;
        this.loadData();
      }
      else {
        this.loadNews();
      }

    });

  }


  summaryInfo = {} as any;
  loadNews() {
    if (this.tickerSymbol != null && this.tickerSymbol != '' && this.tickerSymbol != undefined) {
      this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6102).subscribe(response => {
        if (!response.IsLatestAvailable) {
          this.getSummaryDetails();

        }
        else {
          this.summaryInfo = JSON.parse(response.DataJson);
          this.summaryData = this.summaryInfo?.quoteSummary?.result[0] ? this.summaryInfo?.quoteSummary?.result[0] : null;
          this.showSummary = true;
          this.Loader.display(false);
        }
      });
      this.loadPriceDetails();
    }

    this.Loader.display(false);
  }

  loadPriceDetails() {
    this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6112).subscribe(response => {
      if (!response.IsLatestAvailable) {
        this.getPriceDetails();
      }
      else {
        if (response != null) {
          this.stockInformation = JSON.parse(response.DataJson);
          let stockResponse = this.stockInformation != null && this.stockInformation != undefined ?
            this.stockInformation.quoteResponse.result[0] : null;
          if (stockResponse != null && stockResponse != undefined) {
            const regularMarketPrice = stockResponse["regularMarketPrice"];
            const regularMarketChangePercent = this.formatAsPercentage(stockResponse["regularMarketChangePercent"]);
            const regularMarketChange = stockResponse["regularMarketChange"];
            const regularMarketTime = stockResponse["regularMarketTime"];
            const symbol = stockResponse["symbol"];
            const quoteSourceName = stockResponse["quoteSourceName"];
            this.price = {
              regularMarketPrice,
              regularMarketChangePercent,
              regularMarketChange,
              regularMarketTime,
              symbol,
              quoteSourceName
            }
          }
        }
      }
    });
  }

  stockInformation = {} as any;
  getPriceDetails()
  {
    this.propertyListing.GetStockValues(this.tickerSymbol).subscribe(response => {
      if (response != null) {
        this.stockInformation = response;
        let stockResponse = this.stockInformation != null && this.stockInformation != undefined ?
          this.stockInformation.quoteResponse.result[0] : null;
        if (stockResponse != null && stockResponse != undefined) {
          const regularMarketPrice = stockResponse["regularMarketPrice"];
          const regularMarketChangePercent = this.formatAsPercentage(stockResponse["regularMarketChangePercent"]);
          const regularMarketChange = stockResponse["regularMarketChange"];
          const regularMarketTime = stockResponse["regularMarketTime"];
          const symbol = stockResponse["symbol"];
          const quoteSourceName = stockResponse["quoteSourceName"];
          this.price = {
            regularMarketPrice,
            regularMarketChangePercent,
            regularMarketChange,
            regularMarketTime,
            symbol,
            quoteSourceName
          }
          this.newsDetail.DataJson = JSON.stringify(response);
          this.newsDetail.Ticker = this.tickerSymbol;
          this.newsDetail.TypeId = 6112;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
        }
      }
    });
  }

  formatAsPercentage(rawValue: number): string {
    if (rawValue != null && rawValue != undefined) {
      return `${rawValue.toFixed(2)}%`;
    }
  }

  loadData(value = 0) {
    this.propertyListing.GetDefaultTickers(this.sellerId == 0 ? this.user.Id : this.sellerId).subscribe(response => {

      if (response.length > 0) {
        this.tickerAvailable = true;
        if (value == 0) {
          this.showSummaryTab = true;
        }
        this.tickerSymbol = response[0].Symbol;
        if (this.tickerSymbol != undefined) {
          this.loadNews();
        }
      }
      else {
        this.tickerAvailable = false;
        this._toastService.addToast({
          title: 'Warning',
          msg: 'No tickers available',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'top-right',
          type: 'warning'
        });
        this.Loader.display(false);
        this.showSummaryTab = false;
      }
    });
  }

  financialSummaryTabClick(tab: FinancialSummaryTabs) {
    this.financialSummaryActiveTab = tab;
  }

  getSummaryDetails() {
    this.propertyListing.GetSummaryDetails(this.tickerSymbol).subscribe(response => {
      if (response != null) {
        this.tickerAvailable = true;
        this.summaryData = JSON.stringify(response);
        this.newsDetail.DataJson = JSON.stringify(response);
        this.newsDetail.Ticker = this.tickerSymbol;
        this.newsDetail.TypeId = 6102;
        this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
        });

        this.showSummary = true;
        this.showSummaryTab = true;
      }
      else {
        this.showSummaryTab = false;
        this._toastService.addToast({
          title: 'Info',
          msg: 'No data available for ' + this.tickerSymbol,
          timeout: 5000,
          theme: 'bootstrap',
          position: 'top-right',
          type: 'info'
        });
      }

      this.Loader.display(false);
    });
  }

  getColorForStock(value) {
    if (value != null) {
      value = value.toString();
      if (value.includes('-')) {
        return '#f0605d'
      }
      else {
        return '#28A79B'
      }
    }
  }

}

